<style>
  .mycontainer{
    height: 99vh
  }
</style>
<template>
  <v-container fluid ma-0 pa-0 class="mycontainer">
        <olmap :layersconfig="mapLayers"        />
   </v-container>
</template>

<script>
import {
  APP,
  DEV,
  getLog,
  VERSION,
  BUILD_DATE,
} from '../config';
import olmap from './olmap.vue';

const MODULE_NAME = APP;
const log = getLog(MODULE_NAME, 4, 2);

export default {
  name: APP,
  components: {
    olmap,
  },
  data: () => ({
    title: 'Environnement construit',
    appName: APP,
    appTitle: `${APP} - ${VERSION}`,
    isInDev: DEV,
    mapLayers: {
      baseLayer: 'fonds_geo_osm_bdcad_couleur',
      layerForQueryInit: 'envconst_arbres_public_msgroup,envconst_dangers_naturels_syn,envconst_plantes_envahissantes_msgroup,envconst_eau_prot_msgroup,bdcad_bf_parc_pol,bdcad_bf_parc_pol_dp,bdcad_bf_parc_pol_ddp,bdcad_cs_bati_pol,bdcad_cs_bati_pol_sout',
      wmsLayers: [
        {
          layers: 'envconst_liaisons_biol_foret_msgroup,envconst_liaisons_biol_aqua_msgroup,envconst_liaisons_biol_sec_msgroup',
          title: 'Liaisons biologiques',
          isVisible: false,
        },
        {
          layers: 'envconst_eau_prot_msgroup',
          title: 'Protection des eaux',
          isVisible: false,
        },
        {
          layers: 'envconst_plantes_envahissantes_msgroup',
          title: 'Plantes envahissantes',
          isVisible: false,
        },
        {
          layers: 'envconst_lignes_ht_msgroup',
          title: 'Haute tension - Lignes et mâts',
          isVisible: false,
        },
        {
          layers: 'envconst_dangers_naturels_syn',
          title: 'Dangers naturels',
          isVisible: false,
        },
        {
          layers: 'envconst_arbres_public_msgroup',
          title: 'Arbres',
          isVisible: false,
        },
      ],
    }, // FIN DE LA CONFIG DES mapLayers
  }),
  computed: {
  },
  mounted() {
    log.w(`mounted ${this.appTitle} build: ${BUILD_DATE}`);
  },
  methods: {},
};
</script>
